import SectionHeading from '@/pages/home/components/SectionHeading';
import { dossiers } from '@/mocks/home';

export default function DossiersSection() {
  return (
    <section id="dossiers" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="背景档案"
            title="人物背景档案"
            desc="按人物拆开的背景条目，包含圈层、过往交集与当前待补齐的线索，方便逐条对照。"
          />
          <a
            href="#timeline"
            className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看事件脉络
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {dossiers.map((item, index) => (
            <div key={item.name} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 font-heading text-sm font-bold text-accent-800">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="min-w-0">
                  <h4 className="font-heading text-base font-semibold text-foreground-950">{item.name}</h4>
                  <p className="truncate font-label text-xs text-foreground-500">{item.field}</p>
                </div>
              </div>

              <p className="mt-3.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.background}</p>

              <ul className="mt-4 flex flex-col gap-2 border-t border-background-100 pt-4">
                {item.highlights.map((highlight) => (
                  <li key={highlight} className="flex items-center gap-2 text-xs text-foreground-700 md:text-sm">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-400" />
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}